import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import 'datatables.net-fixedcolumns';
import {css} from "@emotion/core";
import * as moment from "moment";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import CrispBankFilter from '../../filters/CrispBankFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('30', '0', '2020-02-01','0');
var BvReport='';

class BussinessVolumeReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            ciutidIds: '',
            loading:false,
            isChange: false,
            object_code:[],
            state_code:"",
            tableHeaders:[],
            tableBody:[],
            bank_names:"",
            download_limit:31
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "crisp_business_volume_report");
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");



        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });


    }
    componentDidUpdate() {

    }
    componentDidMount() {
        //this.get_download_limit();
        this.get_filtered_link_bv_report('');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'live_transaction_dump_report','sparcs')

    }
    get_download_limit(){
        axios.get(config.get('API_URL')+'/filters/get-grd-download-limit/',
       {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {

            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                download_limit:response.data
            })


        }).catch(error => {
          console.log(error);
        });
    }


    downLoadBvReport (e){
        let filters = {
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            report_code:'business_volume_report',
            user_id: this.state.user_id,
            bank: this.state.bank_names,
            download: 1,
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/crisp_reports/business_volume_report','business_volume_report','60');
    }

    get_filtered_link_bv_report() {

        var that = this;
        var a = moment(this.state.todSend);
        var b = moment(this.state.yestSend);


        var postData = {
            bank: this.state.bank_names,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            report_code:'business_volume_report',
            user_id: this.state.user_id,
        };
        if ($.fn.DataTable.isDataTable('#BvReport')) {
            $('#BvReport').DataTable().clear().destroy();
        }

        BvReport = $('#BvReport').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
//                 fixedColumns:   {
//                                 leftColumns: 0,
//                                 rightColumns: 1
//                             },
                ajax: {
                    url:config.get('API_URL')+ "/CrispReport/business_volume_report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                        console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true)
                        console.log("complete", data);
                    },
                },

                columns:[
                    { "data": "Through debit card Volume" },
                    { "data": "Through debit card Value" },
                    { "data": "Through credit card Volume" },
                    { "data": "Through credit card Value" },
                    { "data": "Through PPI Volume" },
                    { "data": "Through PPI Value" },
                    { "data": "Through UPI Volume" },
                    { "data": "Through UPI Value" },
                    { "data": "Through internet banking Volume" },
                    { "data": "Through internet banking Value" },
                    { "data": "Through mobile banking Volume" },
                    { "data": "Through mobile banking Value" },
                    { "data": "Others (Please specify) Volume" },
                    { "data": "Others (Please specify) Value" },
                    { "data": "Total Volume" },
                    { "data": "Total Value" },
                    { "data": "Bank" }

                    ],
                "columnDefs": [
//                    {  render: function (data) {
//                             if(data===null || data===''|| data ==='null'){
//                                 return "<div class='text-wrap width-80'></div>";
//                             }
//                         else{
//                             return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY HH:mm:ss')+ "</div>";
//                             }
//                         },
//                         "width": "80px",
//                         "targets": 4
//                     }
               ],
            });


    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);

        this.refs.crispBankFilter.resetCrispBankFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            bank_names:'',
            ciutidIds: '',
            isChange: false

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleBank = (optionSelected, bank_names) =>
    {
        this.setState({
            bank_names:bank_names,
            isChange: true
        });
    }

    render() {
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Bussiness Volume Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label>Date Filter: </label></div>
                                                <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            <div className="col-md-3 filter-bottom5 padd-5">
                                                <label> Bank Name </label>
                                                <CrispBankFilter ref="crispBankFilter" onSelectCrispBank = {this.handleBank} />
                                                <div className="clearfix"></div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_link_bv_report.bind(this)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadBvReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>

                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="BvReport" className="table table-striped table-hover">
                                            <thead>
                                                <tr>

                                                  <th colSpan="2" className="centerAlign">Through Debit Card</th>
                                                  <th colSpan="2" className="centerAlign">Through Credit Card</th>
                                                  <th colSpan="2" className="centerAlign">Through PPI</th>
                                                  <th colSpan="2" className="centerAlign">Through UPI</th>
                                                  <th colSpan="2" className="centerAlign">Through Internet Banking</th>
                                                  <th colSpan="2" className="centerAlign">Through Mobile Banking</th>
                                                  <th colSpan="2" className="centerAlign">Others (Please specify)</th>
                                                  <th colSpan="2" className="centerAlign">Total</th>
                                                  <th rowSpan="2" className="centerAlign">Bank</th>
                                                </tr>
                                                <tr>
                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>

                                                  <th>Volume</th>
                                                  <th>Value (Rs.)</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(BussinessVolumeReport)